import { dashboardMapper } from "../../../../domains/mapper/Reports/DashboardMapper";
import urlConfig from "../../../../adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "../../../../adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { dashboardHoldingMapper } from "@domains/mapper/Reports/DashboardHoldingMapper";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class DashboardRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getDashboardData(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        let url;
        if (req === null || req === void 0 ? void 0 : req.isFamily) {
            url = new URL(urlConfig.familyTagging + "/dashboard");
            url.searchParams.append("accountIds", req.accountIds);
        }
        else {
            url = new URL(urlConfig.dashboardUrl);
            url.searchParams.append("accountId", accountCode);
        }
        url.searchParams.append("fromDate", req.fromDate);
        url.searchParams.append("toDate", req.toDate);
        url.searchParams.append("duration", req.duration);
        const DashboardData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return dashboardMapper(DashboardData.data);
    }
    async getHoldingDashboard(req) {
        const accountCode = await this.accountDetails.getAccountCode();
        let url;
        if (req === null || req === void 0 ? void 0 : req.isFamily) {
            url = new URL(urlConfig.familyTagging + "/dashboard/holding/v1");
            url.searchParams.append("accountIds", req.accountIds);
        }
        else {
            url = new URL(urlConfig.dashboardUrl + "/holding/v1");
            url.searchParams.append("accountId", accountCode);
        }
        const accTyp = await this.accountDetails.getAccTyp();
        if (accTyp !== "CO") {
            const DashboardData = await this.http.makeApiCall({
                method: "GET",
                url: url.toString(),
                headers: getReportHeaders(accountCode),
            });
            return dashboardHoldingMapper(DashboardData.data);
        }
    }
}
export default DashboardRepository;
